(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  document.documentElement.classList.add('high-motion-ready');

  const revealItems = document.querySelectorAll(
    '.shopify-section:not(:first-child), .card-wrapper, .multicolumn-list__item'
  );

  revealItems.forEach((item) => item.classList.add('high-reveal'));

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('high-reveal--visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('high-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  revealItems.forEach((item) => observer.observe(item));

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const cursorDrips = document.createElement('span');
  cursorDrips.className = 'high-cursor-drips';
  cursorDrips.setAttribute('aria-hidden', 'true');
  ['lime', 'cyan', 'pink', 'yellow'].forEach((color) => {
    const drip = document.createElement('i');
    drip.className = `high-cursor-drip high-cursor-drip--${color}`;
    cursorDrips.appendChild(drip);
  });
  document.body.appendChild(cursorDrips);

  window.addEventListener(
    'pointermove',
    (event) => {
      document.documentElement.style.setProperty('--high-pointer-x', `${event.clientX}px`);
      document.documentElement.style.setProperty('--high-pointer-y', `${event.clientY}px`);
    },
    { passive: true }
  );

  document.querySelectorAll('.card-wrapper').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const bounds = card.getBoundingClientRect();
      const rotateX = ((event.clientY - bounds.top) / bounds.height - 0.5) * -2.5;
      const rotateY = ((event.clientX - bounds.left) / bounds.width - 0.5) * 2.5;
      card.style.setProperty('--high-rotate-x', `${rotateX}deg`);
      card.style.setProperty('--high-rotate-y', `${rotateY}deg`);
    });
    card.addEventListener('pointerleave', () => {
      card.style.removeProperty('--high-rotate-x');
      card.style.removeProperty('--high-rotate-y');
    });
  });
})();
